/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

const IconAppMenuStripe = () => (
  <svg height="36px" width="16px" viewBox="8 5 26 26">
    <g>
      <path fill="#fff" d="M14.36,18A3.64,3.64,0,1,1,18,21.64,3.64,3.64,0,0,1,14.36,18Z" />
      <path fill="#fff" d="M14.36,5.64A3.64,3.64,0,1,1,18,9.29,3.64,3.64,0,0,1,14.36,5.64Z" />
      <path fill="#fff" d="M14.36,30.36A3.64,3.64,0,1,1,18,34,3.65,3.65,0,0,1,14.36,30.36Z" />
    </g>
  </svg>
);

export default IconAppMenuStripe;
